export default (slides) => ({
  activeSlide: 1,
  slides: slides,
  count: 0,
  interval: null,
  prev(event, resetAuto = true) {
    this.activeSlide = this.activeSlide === 1 ? this.count : this.activeSlide - 1
    if(resetAuto) {
      //this.auto()
    }
  },
  next(event, resetAuto = true) {
    this.activeSlide = this.activeSlide === this.count ? 1 : this.activeSlide + 1
    if(resetAuto) {
      //this.auto()
    }
  },
  auto() {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.next({}, false)
    }, 15000)
  },
  init() {
    this.count = Object.keys(this.slides).length;
    this.$refs['default'].remove()
    //this.auto();
  },
})
